__webpack_require__.p = "/webpage/guess_world_cup/";